import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GoogleAnalyticsService } from '@optimo/core';
import { environment } from '../../../../environments/environment';
import { SEOService } from '../../services/SEO.service';
import { Router } from '@angular/router';
import { isUz, MENUTREE, phoneNumber } from '../../../../config/ui-config';
import { LanguageService } from '../../services/language.service';
import { ELandingPageType } from '../../../core/enums/ELandingPageType';
import { HeaderService } from '../../services/header.service';
import { takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  readonly isUz = isUz;
  readonly phoneNumber = phoneNumber;
  readonly ELandingPageType = ELandingPageType;
  private readonly unsubscribe$ = new Subject<void>();
  tryForContent = 'GENERAL.TryForFree';
  dashboardLoginPageUrl: string = environment.dashboardLoginPageUrl;
  navItems = MENUTREE;
  burgerActive = false;

  @Input()
  theme: 'light' | 'dark' = 'light';

  @Input()
  mode: ELandingPageType;

  @Input()
  isFixed = true;

  @Input()
  landing = false;

  @Input()
  requestButtonVisibility = false;

  constructor(
    @Inject(DOCUMENT) private document: any,
    readonly googleAnalytics: GoogleAnalyticsService,
    readonly translateService: TranslateService,
    readonly seoService: SEOService,
    readonly router: Router,
    readonly languageService: LanguageService,
    readonly headerService: HeaderService,
  ) {}
  ngOnInit() {
    this.listenToTryForContent();
  }

  onLogin(): void {
    this.router.navigate(['/dashboard']).then(() => {
      this.languageService.listenRouterAndNavigateToDashboard();
    });
  }

  getRouterLink(item) {
    const isValidLanguage =
      this.translateService.currentLang === this.translateService.defaultLang;
    return (
      (item.url === '/' && isValidLanguage
        ? ''
        : `/${this.translateService.currentLang}`) + item.url
    );
  }

  onNavigate(item) {
    const url = this.getRouterLink(item);
    if (url == this.router.url) {
      this.burgerActive = !this.burgerActive;
    }
  }

  toggleBurger(): void {
    this.burgerActive = !this.burgerActive;
    const classNameStatus = this.burgerActive ? 'add' : 'remove';
    this.document.body.classList[classNameStatus]('modal-open');
  }

  onRequest(): void {
    this.googleAnalytics.sendEvent('request_order', 'button_click');
  }

  trackToDashboard(): void {
    this.seoService.pushToDataLayer({
      event: 'goToDashboard',
      'event-uid': '9761f9ba-b5db-433e-a13f-3d88230141cf',
    });
    setTimeout(() => {
      this.router.navigate(['/dashboard']).then(() => {
        this.languageService.listenRouterAndNavigateToDashboard();
      });
    }, 1000);
  }

  scrollToTop(path: string) {
    if (
      (this.router.url === `/${this.translateService.currentLang}` ||
        this.router.url === '/') &&
      path === '/'
    ) {
      this.document.body.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }

  get getHomeRoute() {
    const isValidLanguage =
      this.translateService.currentLang === this.translateService.defaultLang;
    return isValidLanguage ? '/' : `/${this.translateService.currentLang}`;
  }

  private listenToTryForContent() {
    if (!isUz) {
      return;
    }
    this.headerService.tryForContent
      .pipe(
        takeUntil(this.unsubscribe$),
        tap((content: string) => {
          this.tryForContent = content;
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
